import Grid from 'react-bootstrap/lib/Grid'
import PropTypes from 'prop-types'
import React from 'react'
import {colors, media} from '../styles'
import {css} from 'glamor'

const style = {
  container: css({
    ...media.sm({
      borderLeft: `1px solid ${colors.lightBorder}`,
      borderRight: `1px solid ${colors.lightBorder}`
    })
  })
}

const Container = ({children, ...props}) => (
  <Grid {...props} {...style.container}>
    {children}
  </Grid>
)

Container.propTypes = {
  children: PropTypes.any
}

export default Container
